import Card, {
  GrayInfoCard,
  InfoCard,
  InfoCardTitle,
  LightBlueInfoCard,
} from '~/components/Card/Card';

export default Card;

export { InfoCard, InfoCardTitle, LightBlueInfoCard, GrayInfoCard };
